export default "https://assets.pclncdn.com/web/next-landing/d6942e80/_next/static/images/cobrand-cruises-only-promo-22829eb309ed1658cbaafb48728200cc.jpg";